import { Action } from '@ngrx/store';

export class RequestSinacorNoteAction implements Action {

    public static requestSinacorNote: string = '[Report] request_sinacor_note';
    public static requestSinacorNoteError: string = '[Report] request_sinacor_note_error';
    public static requestSinacorNoteSuccess: string = '[Report] request_sinacor_note_success';

    constructor(
        public type: string,
        public payload?: any,
    ) {}
}
